import React from 'react';
import { HiOutlineExclamation, HiOutlineCheckCircle, HiOutlineInformationCircle } from 'react-icons/hi';

const ICONS = {
    good:    <HiOutlineCheckCircle size={18} />,
    bad:     <HiOutlineExclamation size={18} />,
    neutral: <HiOutlineInformationCircle size={18} />
};

const InsightsPanel = ({ insights = [], periodA, periodB }) => {
    if (!insights.length) return null;

    return (
        <div className="fr-insights-panel">
            <div className="fr-insights-header">
                <h3>What changed</h3>
                <span>{periodA?.label} vs {periodB?.label}</span>
            </div>
            <ul className="fr-insights-list">
                {insights.map((ins, idx) => (
                    <li key={idx} className={`fr-insight fr-insight-${ins.kind}`}>
                        <span className="fr-insight-icon">{ICONS[ins.kind] || ICONS.neutral}</span>
                        <span>{ins.text}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default InsightsPanel;
